import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

// Services
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { AdminService } from '../../services/admin.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { NgIf } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-andon-groups-dialog',
    templateUrl: './andon-groups-dialog.component.html',
    styleUrls: ['./andon-groups-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgIf, MatFormField, MatInput, CdkTextareaAutosize, MatButton, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogActions]
})
export class AndonGroupsDialogComponent implements OnInit {

  adminFlag: boolean;
  adminSub$: Subscription;

  input: AndonGroupsType;
  data: any[];

  title:string;

  addFormGroup: UntypedFormGroup;

  displayedObjectColumns: string[] = ['AndonGroup','actions']

  constructor(public dialogRef: MatDialogRef<AndonGroupsDialogComponent>,
    private svcAdmin: AdminService,
    private fb: UntypedFormBuilder,
    private geaMesCognito: GeaMesCognitoAuthService,
    @Inject(MAT_DIALOG_DATA) public inData: AndonGroupsType) { 
      this.input = inData['objData'];
    }

  ngOnInit(): void {
    this.title = `${this.input.ObjectID}: ${this.input.Description}`
    // Check to see if this user is an admin
    this.adminSub$ = this.geaMesCognito.isUserInRole("Admin").pipe(first()).subscribe( out => { 
      this.adminFlag = out;
      if (this.adminSub$) this.adminSub$.unsubscribe(); // We've got an answer, can unsubscribe now
    });    

    this.getAndonList();

    this.addFormGroup = this.fb.group({
      NewAndonGroup: ''
    });
  }

  getAndonList() {
    this.svcAdmin.andonGroupList(this.input.Site, this.input.Environment, this.input.ObjectID).subscribe((
      out => {
          console.debug(out);
          this.data = out.Body;
          this.data.push({"Andon_Group": ""})
    }));
  }

  delete(AndonGroup:string) {
    if (confirm(`Are you sure to delete ${AndonGroup} from ${this.input.ObjectID}?`)) {
      this.svcAdmin.andonGroupDelete(this.input.Site, this.input.Environment, this.input.ObjectID, AndonGroup).subscribe((
        out => {
            console.debug(out);
            this.getAndonList();
      }));    
    }
  }

  add() {
    let NewAndonGroup:string = this.addFormGroup.controls.NewAndonGroup.value;
    if (NewAndonGroup.trim() != "") {
      this.svcAdmin.andonGroupAdd(this.input.Site, this.input.Environment, this.input.ObjectID, NewAndonGroup).subscribe((
        out => {
            console.debug(out);
            this.addFormGroup = this.fb.group({
              NewAndonGroup: ''
            });          
            this.getAndonList();
      }));
    }
  }

  close() {
    this.dialogRef.close();
  }

}

export interface AndonGroupsType {
  Site: string;
  Environment: string;
  ObjectID: string;
  Description: string;
}